/** @jsx jsx */
/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Avatar } from '@coursera/cds-core';
import { HistoryIcon, SearchIcon } from '@coursera/cds-icons';

import TrendingIcon from 'bundles/search-common/components/searchbar/autocomplete/TrendingIcon';
import SparkleIcon from 'bundles/unified-common/components/coach-on-discovery/SparkleIcon';

const styles = {
  iconWrapper: css`
    /* to fix vertical icon alignment with option text */
    display: flex;
    align-self: center;
    color: var(--cds-color-neutral-primary);
  `,
};

const AutoCompleteGroupIdToIconMap: Record<string, React.ReactElement> = {
  trending: <TrendingIcon />,
  default: <SearchIcon data-testid="default-icon" size="medium" />,
  recentSearches: <HistoryIcon size="medium" />,
  aiPromptsAsYouType: <SparkleIcon size="medium" />,
};

type Props = { imageUrl?: string; groupId?: string; avatarAltText?: string; isAiPrompt?: boolean };

export const AutocompleteItemIcon = (props: Props): React.ReactElement => {
  const { imageUrl, groupId = '', avatarAltText = 'Coursera', isAiPrompt } = props;
  // AI prompts from recent searches keep their sparkle icon regardless of group
  const resolvedGroupId = isAiPrompt ? 'aiPromptsAsYouType' : groupId;

  return (
    <div css={styles.iconWrapper}>
      {imageUrl ? (
        <Avatar
          size={32}
          variant="organization"
          initial={avatarAltText.charAt(0)}
          imgProps={{ src: imageUrl, alt: avatarAltText }}
        />
      ) : (
        <>{AutoCompleteGroupIdToIconMap[resolvedGroupId] ?? AutoCompleteGroupIdToIconMap.default} </>
      )}
    </div>
  );
};

export default AutocompleteItemIcon;
